import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class RelatorService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    list() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/relatores`, { headers }).toPromise();
    }
    update(user) {
        return this.http.post(`${this.configService.API_URL}/relatores/update`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/relatores`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllCategorias() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/relatores`, { headers }).toPromise();
    }
    getUltimoId() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/relatores/ultimoId`, { headers }).toPromise();
    }
    delete(user, relatorId) {
        return this.http.post(`${this.configService.API_URL}/relatores/delete/${relatorId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
}
RelatorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RelatorService_Factory() { return new RelatorService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: RelatorService, providedIn: "root" });
